export const theme = {
  primaryColor: "#001aec",
  lightPrimaryColor: "#3339f2",
  textColor: "#fff",
  containerBackgroundColor: "#fff",
  footerColor: "#d9d9d9",
  mainPageSearchColor: "#f7f8ff",
  backgroundGrayColor: "#FAFAFA",
  faqColor: "#722ED1",
};
